document.querySelectorAll('[data-pdp-usage]').forEach(function (stack) {
  var rows = Array.prototype.slice.call(stack.querySelectorAll('[data-pdp-usage-row]'));
  if (rows.length < 2) return;

  function activate(targetRow) {
    rows.forEach(function (row) {
      var isTarget = row === targetRow;
      row.classList.toggle('is-expanded', isTarget);
      var trigger = row.querySelector('[data-pdp-usage-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', String(isTarget));
    });
  }

  rows.forEach(function (row) {
    row.addEventListener('click', function () {
      if (!row.classList.contains('is-expanded')) activate(row);
    });
  });
});
